import { render, staticRenderFns } from "./consultProcessjiaoban.vue?vue&type=template&id=6b1ee057&scoped=true&"
import script from "./consultProcessjiaoban.vue?vue&type=script&lang=js&"
export * from "./consultProcessjiaoban.vue?vue&type=script&lang=js&"
import style0 from "./consultProcessjiaoban.vue?vue&type=style&index=0&id=6b1ee057&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1ee057",
  null
  
)

export default component.exports